// extracted by mini-css-extract-plugin
export default {"container":"UiMarkdown_container"};